import { useFormDialog } from '@if/mui'
import {
  getAgentWithdrawalReason,
  useEditAgentWithdrawalReason,
} from '@src/data/api/agent-withdrawal-reason/agent-withdrawal-reason-api'
import { useTranslation } from 'react-i18next'
import {
  type AgentWithdrawalReasonFormValues,
  OTHER_REASON_ID,
  useAgentWithdrawalReasonSchema,
} from './agentWithdrawalReasonForm'
import AgentWithdrawalReasonDialogContent, {
  type AgentWithdrawalReasonOpenProps,
} from './components/AgentWithdrawalReasonDialog'

export const useAgentWithdrawalReasonDialog = () => {
  const { t } = useTranslation()
  const [editAgentWithdrawalReason] = useEditAgentWithdrawalReason()
  const schema = useAgentWithdrawalReasonSchema()

  const dialog = useFormDialog<AgentWithdrawalReasonFormValues, AgentWithdrawalReasonOpenProps, void>({
    title: t('agentWithdrawalReason.label'),
    maxWidth: 'md',
    fullWidth: true,
    schema,
    defaultValues: async ({ financingProgramId, creditApplicationId }) => {
      const savedReason = await getAgentWithdrawalReason(financingProgramId, creditApplicationId)
      return { reasonId: savedReason?.reasonId ?? '', comment: savedReason?.comment ?? '' }
    },
    content: (ctx) => <AgentWithdrawalReasonDialogContent ctx={ctx} />,
    onSubmit: async (data, ctx) => {
      await editAgentWithdrawalReason({
        financingProgramId: ctx.props.financingProgramId,
        creditApplicationId: ctx.props.creditApplicationId,
        reasonId: data.reasonId,
        comment: data.reasonId === OTHER_REASON_ID ? (data.comment?.trim() ?? null) : null,
      })
    },
  })

  return { open: (props: AgentWithdrawalReasonOpenProps) => dialog.edit(props) }
}
